/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import moment from 'moment'
import { useMemo } from 'react'
import { useAuth } from '../useAuth'
import { useTimeout } from '../../hooks/useTimeout'

const TOLERANCE_MIN = window.env.VITE_TOKEN_REFRESH_BEFORE_MINUTES

export const useTokenRefresher = () => {
  const { tokenExpirationDate, refreshToken } = useAuth()
  // const { showTokenRefreshLogs } = useDevSettings()

  const expireIn = useMemo(() => {
    if (tokenExpirationDate == null) return null

    const expirationDate = moment(tokenExpirationDate)
    const ms = expirationDate.diff(moment(), 'seconds') * 1000
    const tolerance = TOLERANCE_MIN * 1000 * 60
    const expiresIn = ms - tolerance
    return expiresIn
  }, [tokenExpirationDate])

  const timeout = useTimeout(
    () => {
      refresh()
    },
    expireIn
  )

  const refresh = () => {
    // if (showTokenRefreshLogs) {
    //   log('session - Refreshing token...')
    // }
    try {
      refreshToken()
    } catch (ex) {
      window.clearTimeout(timeout.current || 0)
    }
  }
}
